import { createContext, useContext } from 'react';

type FavoritesPageContextType = {
    areButtonsDisabled: boolean;
    disableButtons: () => void;
    enableButtons: () => void;
};

const FavoritesPageContext = createContext<FavoritesPageContextType>({
    areButtonsDisabled: false,
    disableButtons: () => {},
    enableButtons: () => {}
});

export const useFavoritesPageContext = () => useContext(FavoritesPageContext);

export default FavoritesPageContext;
